module.exports = __webpack_public_path__ + "img/千金子.297e73f7.jpg";